import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { HYDRATE } from 'next-redux-wrapper';

import { ServerReqHeader } from '@/types';

// Define a type for the slice state
export interface CommonState {
  req: { header: ServerReqHeader | null };
}

// Define the initial state using that type
const initialState: CommonState = {
  req: {
    header: null,
  },
};

export const commonSlice = createSlice({
  name: 'common',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setReqHeader: (state, action: PayloadAction<ServerReqHeader>) => {
      state.req.header = {
        host: action.payload?.host || globalThis?.location?.host || '',
        referer:
          action.payload?.referer || globalThis?.document?.referrer || '',
      };
    },
    removeReqHeader: (state) => {
      state.req.header = null;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.common,
      };
    },
  },
});

export const { setReqHeader, removeReqHeader } = commonSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectReqHeader = (state: RootState) => state.common.req?.header;

export default commonSlice;
